import moment from 'moment-timezone';
import React, {useState, useEffect} from 'react'

// Redux
import { useSelector, useDispatch } from 'react-redux'
import { getMassEmailOptions, submitMassEmailOptions, performMassEmailSubmission } from '../../../../../store/actions/reviewsEmail'
import { userTokenUpdate, userLogout } from "../../../../../store/actions/user";
import { addRoute } from "../../../../../store/actions/route";

import GeneralLoader from '../../../../GeneralLoader';
import AdminMassEmailForm from './AdminMassEmailForm';
import AdminMassEmailSend from './AdminMassEmailSend';

const AdminMassEmail = () => {
    const [formData, setFormData] = useState({});
    const dispatch       = useDispatch();
    const stateReviewsEmail = useSelector(state => state.reviewsEmail);

    useEffect(() => {
        (() => {
            // Add route for Admin Nav Active tracking
            dispatch(addRoute({
                type: '',
                route: '/admin/mass-email'
            }))

            // Fetch data from API, then store into local component state for form
            dispatch(getMassEmailOptions()).then((resp) => {
                if (resp.data.status === 403) {
                    dispatch(userLogout("admin"));
                    return;
                }

                // Set data and format dates to moment objects for date picker
                setFormData({
                    ...resp.data.options,
                    date_start: !!resp.data.options.date_start
                        ? moment(resp.data.options.date_start)
                        : null,
                    date_end: resp.data.options.date_end
                        ? moment(resp.data.options.date_end)
                        : null,
                });
            })
        })()
    }, [])

    const handleInputChange = (event) => {
		const { id, value } = event.target;

        setFormData((formData) => ({
            ...formData,
            [id]: value
        }))
    }

    const handleCheckboxChange = (event) => {
		const { id } = event.target;

        setFormData((formData) => ({
            ...formData,
            [id]: formData[id] === 0 ? 1 : 0
        }))
    }

    const handleDateChange = (value, id) => {
        setFormData((formData) => ({
            ...formData,
            [id]: value
        }))
    }

    // const handleSectorCheckboxChange = (event) => {
	// 	const { id } = event.target;

    //     setFormData((formData) => ({
    //         ...formData,
    //         sectors: {
    //             ...formData.sectors,
    //             [id]: formData.sectors[id] == 0 ? 1 : 0
    //         }
    //     }))
    // }

    // When form options are saved
    const handleFormSubmit = () => {
        dispatch(submitMassEmailOptions(formData)).then((response) => {
            if (!!response.data.token) {
                dispatch(userTokenUpdate("admin", response.data.token));
            }
            if (response.data.status === 403) {
                dispatch(userLogout("admin"));
                return;
            }
        });
    }

    // When mass email is performed
    const handleEmailSubmit = () => {
        dispatch(performMassEmailSubmission()).then((response) => {
            if (!!response.data.token) {
                dispatch(userTokenUpdate("admin", response.data.token));
            }
            if (response.data.status === 403) {
                dispatch(userLogout("admin"));
                return;
            }
        });
    }

    return (
		<React.Fragment>
            <div className="linked-title">
                <h1>Reviews - Mass Email</h1>
            </div>

            {/* Options Loading */}
            {stateReviewsEmail.optionsLoading 
                ? <GeneralLoader /> 
                : (
                    <React.Fragment>
                        <AdminMassEmailForm 
                            data={formData}
                            loading={stateReviewsEmail.optionsLoading}
                            errors={stateReviewsEmail.optionsError}
                            success={stateReviewsEmail.optionsSuccess}
                            handleInputChange={e => handleInputChange(e)}
                            handleDateChange={(date, id) => handleDateChange(date, id)}
                            handleCheckboxChange={e => handleCheckboxChange(e)}
                            // handleSectorCheckboxChange={e => handleSectorCheckboxChange(e)}
                            handleSubmit={() => handleFormSubmit()}
                        />

                        <AdminMassEmailSend 
                            loading={stateReviewsEmail.submissionLoading}
                            errors={stateReviewsEmail.submissionError}
                            success={stateReviewsEmail.submissionSuccess}
                            handleEmailSubmit={() => handleEmailSubmit()}
                        />
                    </React.Fragment>
                )
            }
        </React.Fragment>
    )
}

export default AdminMassEmail


// WEBPACK FOOTER //
// ./src/components/admin/reviews/reviews-email/mass-email/AdminMassEmail.js